import { apiConfig, tryRefresh } from "./api";
import { useAuthStore } from "@/store/authStore";

/**
 * 凭证图片上传（multipart）· 复用 authStore 的 token/tenant · 401 时刷新 token 重试一次 · 返回 {url, key}。
 *
 * kind=public 仅限产品图/图集/品牌 Logo 等本就要被 C 端/HUB/GYG 匿名读取的素材（调用方显式传）；
 * 不传时吃后端默认 private（SEC-2 安全默认——报销凭证/车辆证照等敏感件走鉴权路由）。
 */
export async function uploadReceipt(
  file: Blob,
  filename = "scan.jpg",
  kind?: "public" | "private",
): Promise<{ url: string; key: string }> {
  const doUpload = () => {
    const token = useAuthStore.getState().accessToken;
    const tenantSlug = useAuthStore.getState().user?.tenantSlug;
    const fd = new FormData();
    fd.append("file", file, filename);
    if (kind) fd.append("kind", kind);
    return fetch(`${apiConfig.base}/api/v1/uploads`, {
      method: "POST",
      headers: {
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(tenantSlug ? { "X-Tenant-Slug": tenantSlug } : {}),
        // 不设 Content-Type · 让浏览器带 multipart boundary
      },
      body: fd,
    });
  };

  let res = await doUpload();
  // token 过期 → 走与 api() 同款 refresh，刷新成功后用新 token 重传一次
  if (res.status === 401 && useAuthStore.getState().refreshToken) {
    const ok = await tryRefresh();
    if (ok) res = await doUpload();
  }
  if (!res.ok) {
    const t = await res.text().catch(() => "");
    throw new Error(`上传失败 ${res.status}: ${t.slice(0, 140)}`);
  }
  return res.json();
}
